import {AsyncThunkPayloadCreator, createAsyncThunk, SerializedError} from "@reduxjs/toolkit";
import firebase from "firebase";

export function createErrorHandlingThunk<Returned, ThunkArg = void>(
    prefix: string,
    creator: AsyncThunkPayloadCreator<Returned, ThunkArg>
) {
    return createAsyncThunk<Returned, ThunkArg>(prefix, async (arg, thunkAPI) => {
        try {
            return await creator(arg, thunkAPI);
        } catch (err) {
            // console.log("hier", err);
            const error: firebase.FirebaseError = err;
            const serializedError: SerializedError = {
                name: error.name,
                message: error.message,
                code: error.message.includes('permission') ? '403' : error.code
            };

            return Promise.reject(serializedError);
        }
    });
}
